import styled from 'styled-components';
import { Typography } from 'antd';

export const ExpectedCompletionTitle = styled(Typography.Text)`
  &.ant-typography {
    font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.SM}px;
    text-transform: capitalize;
  }
`;

export const ExpectedCompletionValue = styled(Typography.Text)`
  &.ant-typography {
    font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.LG}px;
    font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
  }
`;

export const ExpectedCompletionDescription = styled(Typography.Text)`
  &.ant-typography {
    font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.SM}px;
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_SECONDARY};
  }
`;

export const IconContainer = styled.div`
  width: ${({ theme: { kcc } }): number => kcc.size.S300}px;
  height: ${({ theme: { kcc } }): number => kcc.size.S300}px;
`;
